import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_URL } from '../../../api/api';
const API_BRANCH = `${API_URL}/branches`;

const API_EMPLOYEE = `${API_URL}/employees`;

const AddMemberLayer = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const [branches, setBranches] = useState([]);
    const [employee, setEmployee] = useState([]);
    const [groups, setGroups] = useState([]);
    const [members, setMembers] = useState([]);
    const [form, setForm] = useState({
        advisor: '',
        groups: '',
        branchname: '',
        enrollmentdate: '',
        title: 'Mr.',
        firstname: '',
        middlename: '',
        lastname: '',
        gender: 'Female',
        dob: '',
        occupation: '',
        fathersname: '',
        husbandwifename: '',
        email: '',
        mobile: '',
        collectiontime: '',
        maritalstatus: 'No',
        aadharno: '',
        panno: '',
        meterno: '',
        clrelation: '',
        altmobile: '',
        voterid: '',
        rationcard: '',
        cino: '',
        dlno: '',
        nomineename: '',
        nomineemobile: '',
        nomineevoterid: '',
        nomineeaddress: '',
        userfile: null,
        nomineerelation: '',
        nomineeaadharno: '',
        nomineepan: '',
        address: '',
        landmark: '',
        city: '',
        state: 'Bihar',
        pincode: '',
        houseno: '',
        lat: '0',
        longs: '0',
        addressp: '',
        landmarkp: '',
        cityp: '',
        statep: '',
        pincodep: '',
        housenop: '',
        latp: '0',
        longsp: '0',
        checkfield: false,

    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [branchesRes, employeeRes] = await Promise.all([
                    axios.get(API_BRANCH),
                    axios.get(API_EMPLOYEE)
                ]);

                setBranches(branchesRes.data);
                setEmployee(employeeRes.data.data);

                if (id) {
                    const memberRes = await axios.get(`${API_URL}/members/${id}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });

                    const data = memberRes.data;

                    // Fetch groups for this branch
                    if (data.branchname) {
                        const groupsRes = await axios.get(`${API_URL}/branches/${data.branchname}/groups`);
                        setGroups(groupsRes.data);
                    }

                    setForm(prev => ({
                        ...prev,
                        ...data,
                        enrollmentdate: data.enrollmentdate?.split('T')[0] || '',
                        checkfield: false,
                    }));
                }
            } catch (error) {
                Swal.fire('Error', 'Failed to fetch data.', 'error');
            }
        };

        fetchData();
    }, [id]);



    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        Object.entries(form).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
                // Convert boolean to int for MySQL (especially for checkfield)
                const safeValue = typeof value === 'boolean' ? (value ? 1 : 0) : value;
                formData.append(key, safeValue);
            }
        });

        try {
            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                }
            };

            let response;
            if (id) {
                response = await axios.post(`${API_URL}/members/${id}?_method=PUT`, formData, config);
                Swal.fire('Updated', 'Member has been updated successfully.', 'success');
            } else {
                response = await axios.post(`${API_URL}/members`, formData, config);
                Swal.fire('Created', 'Member has been added successfully.', 'success');
            }

            navigate('/manage-member');
        } catch (error) {
            if (error.response && error.response.status === 422) {
                const errors = error.response.data.errors;
                const errorList = Object.values(errors).flat().join('<br>');
                Swal.fire({
                    icon: 'error',
                    title: 'Validation Error',
                    html: errorList,
                });
            } else {
                Swal.fire('Error', 'An unexpected error occurred.', 'error');
            }
        }
    };



    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === 'file') {
            setForm(prev => ({ ...prev, [name]: files[0] }));
        } else if (type === 'checkbox') {
            setForm(prev => ({ ...prev, [name]: checked }));
            if (name === 'checkfield' && checked) {
                // Auto-fill permanent address fields from correspondence address
                setForm(prev => ({
                    ...prev,
                    addressp: prev.address,
                    landmarkp: prev.landmark,
                    cityp: prev.city,
                    statep: prev.state,
                    pincodep: prev.pincode,
                    housenop: prev.houseno,
                    latp: prev.lat,
                    longsp: prev.longs,
                }));
            }
        } else {
            setForm(prev => ({ ...prev, [name]: value }));
        }
    };
    const handleBranchChange = async (option) => {
        const branchId = option?.value ?? '';
        setForm(prev => ({
            ...prev,
            branchname: branchId,
            groups: '',
            member_id: '',
            membernames: ''
        }));

        if (branchId) {
            try {
                const res = await axios.get(`${API_URL}/branches/${branchId}/groups`);
                setGroups(res.data);
                setMembers([]);
            } catch (error) {
                console.error("Error loading groups:", error);
            }
        }
    };



    return (
        <form onSubmit={handleSubmit} className="container py-4" encType="multipart/form-data">
            {/* Section: Basic Info */}
            <div className="card mb-4 shadow-sm">
                <div className="card-header bg-primary text-white fw-bold">Basic Information</div>
                <div className="card-body row g-3">

                    {/* Advisor */}
                    <div className="col-md-6">
                        <label className="form-label">Associate/Advisor/Staff</label>
                        <select className="form-select" name="advisor" value={form.advisor} onChange={handleChange} required>
                            <option value="">Select Advisor</option>
                            {employee.map(emp => (
                                <option key={emp.id} value={emp.id}>{emp.firstname}</option>
                            ))}
                        </select>
                    </div>

                    {/* Branch */}
                    <div className="col-md-6">
                        <label className="form-label">Branch</label>
                        <select
                            className="form-select"
                            name="branchname"
                            value={form.branchname}
                            onChange={(e) => {
                                const value = e.target.value;
                                setForm(prev => ({ ...prev, branchname: value, groups: '' }));
                                handleBranchChange({ value }); // FIX: properly pass value to fetch groups
                            }}
                            required
                        >
                            <option value="">Select Branch</option>
                            {branches.map(b => (
                                <option key={b.id} value={b.id}>{b.branchname}</option>
                            ))}
                        </select>




                    </div>

                    {/* Group */}
                    <div className="col-md-6">
                        <label className="form-label">Groups</label>
                        <select className="form-select" name="groups" value={form.groups} onChange={handleChange}>
                            <option value="">Select Group</option>
                            {groups.map(group => (
                                <option key={group.id} value={group.id}>
                                    {group.groupname}
                                </option>
                            ))}
                        </select>

                    </div>

                    {/* Enrollment Date */}
                    <div className="col-md-6">
                        <label className="form-label">Enrollment Date</label>
                        <input type="date" className="form-control" name="enrollmentdate" value={form.enrollmentdate} onChange={handleChange} required />
                    </div>
                </div>
            </div>

            <div className="card mb-4 shadow-sm">
                <div className="card-header bg-info text-white fw-bold">Member’s Personal Information</div>
                <div className="card-body row g-3">
                    {/* Title (Radio) */}
                    <div className="col-md-12">
                        <label className="form-label">Title</label>
                        <div className="d-flex flex-wrap gap-3">
                            {['Mr.', 'Mrs.', 'Ms.', 'Md.'].map((t, i) => (
                                <div className="form-check" key={i}>
                                    <input className="form-check-input" type="radio" name="title" value={t} id={`title-${i}`} checked={form.title === t} onChange={handleChange} />
                                    <label className="form-check-label" htmlFor={`title-${i}`}>{t}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Reuse this structure for fields */}
                    {[
                        { label: 'First Name', name: 'firstname' },
                        { label: 'Last Name', name: 'lastname' },
                        { label: 'Middle Name', name: 'middlename' },
                        { label: 'Occupation', name: 'occupation' },
                        { label: 'Father\'s Name', name: 'fathersname' },
                        { label: 'Husband/Wife Name', name: 'husbandwifename' },
                        { label: 'Email', name: 'email', type: 'email' },
                        { label: 'Mobile', name: 'mobile', type: 'number' },
                        { label: 'Date of Birth', name: 'dob', type: 'date' },
                        { label: 'Collection Time', name: 'collectiontime', type: 'time' },
                    ].map(({ label, name, type = "text" }) => (
                        <div className="col-md-6" key={name}>
                            <label className="form-label">{label}</label>
                            <input type={type} className="form-control" name={name} value={form[name]} onChange={handleChange} required />
                        </div>
                    ))}

                    {/* Photo */}
                    <div className="col-md-6">
                        <label className="form-label">Photo</label>
                        <input type="file" className="form-control" name="userfile" onChange={handleChange} />
                    </div>
                </div>
            </div>


            {/* KYC Section */}
            <div className="card mb-4 shadow-sm">
                <div className="card-header bg-light fw-bold text-primary">Member's KYC</div>
                <div className="card-body row g-3">
                    {['aadharno', 'panno', 'meterno', 'clrelation', 'altmobile'].map(field => (
                        <div className="col-md-6" key={field}>
                            <label className="form-label">
                                {field.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/no/i, 'No.')}
                            </label>
                            <input
                                type={field.includes('mobile') || field === 'aadharno' ? 'number' : 'text'}
                                className="form-control"
                                name={field}
                                value={form[field]}
                                onChange={handleChange}
                            />
                        </div>
                    ))}
                    {['voterid', 'rationcard', 'cino', 'dlno'].map(field => (
                        <div className="col-md-6" key={field}>
                            <label className="form-label">{field.toUpperCase()}</label>
                            <input
                                type="text"
                                className="form-control"
                                name={field}
                                value={form[field]}
                                onChange={handleChange}
                            />
                        </div>
                    ))}
                </div>
            </div>


            <div className="card mb-4 shadow-sm">
                <div className="card-header bg-light fw-bold text-primary">Nominee Info</div>
                <div className="card-body row g-3">
                    {['nomineename', 'nomineemobile', 'nomineevoterid', 'nomineeaddress'].map(field => (
                        <div className="col-md-6" key={field}>
                            <label className="form-label">
                                {field.replace('nominee', 'Nominee ').replace(/([a-z])([A-Z])/g, '$1 $2')}
                            </label>
                            <input
                                type={field.includes('mobile') ? 'number' : 'text'}
                                className="form-control"
                                name={field}
                                value={form[field]}
                                onChange={handleChange}
                            />
                        </div>
                    ))}
                    {[
                        { label: 'Nominee Relation', name: 'nomineerelation' },
                        { label: 'Nominee Aadhar No.', name: 'nomineeaadharno' },
                        { label: 'Nominee Pan No.', name: 'nomineepan' }
                    ].map(({ label, name }) => (
                        <div className="col-md-6" key={name}>
                            <label className="form-label">{label}</label>
                            <input
                                type="text"
                                className="form-control"
                                name={name}
                                value={form[name]}
                                onChange={handleChange}
                            />
                        </div>
                    ))}
                </div>
            </div>


            <div className="card mb-4 shadow-sm">
                <div className="card-header bg-light fw-bold text-primary">Correspondence Address</div>
                <div className="card-body row g-3">
                    {['address', 'landmark', 'city', 'state'].map(field => (
                        <div className="col-md-6" key={field}>
                            <label className="form-label">{field.charAt(0).toUpperCase() + field.slice(1)}</label>
                            <input
                                type="text"
                                className="form-control"
                                name={field}
                                value={form[field]}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    ))}
                    {[
                        { label: 'Pincode', name: 'pincode' },
                        { label: 'House No.', name: 'houseno' },
                        { label: 'Lat', name: 'lat' },
                        { label: 'Long', name: 'longs' }
                    ].map(({ label, name }) => (
                        <div className="col-md-6" key={name}>
                            <label className="form-label">{label}</label>
                            <input
                                type="text"
                                className="form-control"
                                name={name}
                                value={form[name]}
                                onChange={handleChange}
                                required={name === 'pincode'} // Only pincode is required
                            />
                        </div>
                    ))}

                </div>

                <div className="card-footer bg-white border-top mt-3">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="check1"
                            name="checkfield"
                            checked={form.checkfield}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setForm(prev => ({
                                    ...prev,
                                    checkfield: checked,
                                    ...(checked
                                        ? {
                                            addressp: prev.address,
                                            landmarkp: prev.landmark,
                                            cityp: prev.city,
                                            statep: prev.state,
                                            pincodep: prev.pincode,
                                            housenop: prev.houseno,
                                            latp: prev.lat,
                                            longsp: prev.longs,
                                        }
                                        : {})
                                }));
                            }}
                        />
                        <label className="form-check-label ms-2" htmlFor="check1">
                            Same as Correspondence Address
                        </label>
                    </div>
                </div>
            </div>

            {/* Permanent Address */}
            <div className="card mb-4 shadow-sm">
                <div className="card-header bg-light fw-bold text-primary">Permanent Address</div>
                <div className="card-body row g-3">
                    {['addressp', 'landmarkp', 'cityp', 'statep'].map(field => (
                        <div className="col-md-6" key={field}>
                            <label className="form-label">{field.replace('p', '')}</label>
                            <input
                                type="text"
                                className="form-control"
                                name={field}
                                value={form[field]}
                                onChange={handleChange}
                                required
                                disabled={form.checkfield}
                            />
                        </div>
                    ))}
                    {['pincodep', 'housenop', 'latp', 'longsp'].map(field => (
                        <div className="col-md-6" key={field}>
                            <label className="form-label">{field.replace('p', '')}</label>
                            <input
                                type="text"
                                className="form-control"
                                name={field}
                                value={form[field]}
                                onChange={handleChange}
                                required={field !== 'housenop'}
                                disabled={form.checkfield}
                            />
                        </div>
                    ))}
                </div>
            </div>
            <div className="text-center my-4 mt-10">
                <button type="submit" className="btn btn-lg btn-primary px-5 shadow">
                    Submit
                </button>
            </div>

        </form>
    );
};

export default AddMemberLayer;
